import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from '@/store/theme';
import type { ThemePreference } from '@/store/theme';
import { useT } from '@/i18n';
import type { TranslationKey } from '@/i18n';

const NEXT_LABEL: Record<ThemePreference, TranslationKey> = {
  light: 'theme.light',
  dark: 'theme.dark',
  system: 'theme.system',
};

const ICONS: Record<ThemePreference, typeof Sun> = {
  light: Sun,
  dark: Moon,
  system: Monitor,
};

export function ThemeToggle() {
  const preference = useTheme((s) => s.preference);
  const cycle = useTheme((s) => s.cycle);
  const t = useT();
  const Icon = ICONS[preference];
  const label = t(NEXT_LABEL[preference]);

  return (
    <button
      type="button"
      onClick={cycle}
      aria-label={label}
      title={label}
      className="grid size-9 place-items-center rounded-sm text-muted transition-colors hover:bg-surface-raised hover:text-ink"
    >
      <Icon className="size-[1.125rem]" strokeWidth={1.75} aria-hidden="true" />
    </button>
  );
}
